import { z } from "zod";

const RoomMaintenanceFilterSchema = z.object({
    room_type_id: z.string().nullable().optional(),
    room_id: z.string().nullable().optional(),
    date_type: z.nullable(z.enum(["all", "date", "checkin_date", "checkout_date"])).optional(),
    gte: z.nullable(z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable()).optional(),
    lte: z.nullable(z.string().regex(/^\d{4}-\d{2}-\d{2}$/)).optional(),
});

export { RoomMaintenanceFilterSchema };
export type RoomMaintenanceFilter = z.infer<typeof RoomMaintenanceFilterSchema>;
